
<div style="width:500px;">
  <div style="width:99%;">
  <span> <button class="btn btn border" (click)="saveCountry()" [disabled]="!form.dirty">Spara</button>  <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
  <br><br>
 <form [formGroup]="form">

  <div class="row">
 <!--div class="col-md-2">
   <label>
     Id
   </label>
   <input id="id" type="text" class="form-control form-control-sm" formControlName="id"
     readonly>
   </div-->
   <div class="col-md-4">
     <label>
       Iso Code
     </label>
     <input id="isoCode" type="text" class="form-control form-control-sm" formControlName="name">
   </div>

   <div class="col-md-2">
     <label>
      Namn
     </label>
     <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
   </div>

   <div class="col-md-2">
    <label>
     Sorteringsordning
    </label>
    <input id="order" type="text" class="form-control form-control-sm" formControlName="order">
  </div>

 </div>
   </form>
</div>
  </div>





